export const notificationsChangedEvent = "ja:notifications-changed";

export function notifyNotificationsChanged() {
  window.dispatchEvent(new Event(notificationsChangedEvent));
}
